var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"chart-container-2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }